import(/* webpackMode: "eager", webpackExports: ["UserAgreementPage"] */ "/app/src/app/(browse)/(content)/user-agreement/UserAgreementPage.tsx");
